"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _colors = require("HubStyleTokens/colors");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var StorefrontCollection = _interopRequireWildcard(require("../../../constants/StorefrontCollection"));

var _urls = require("../../../utils/urls");

var _RouterCallout = _interopRequireDefault(require("./RouterCallout"));

var getI18nKey = function getI18nKey(key) {
  return "appMarketplace.amplify.abm.callout." + key;
};

var AbmCallout = function AbmCallout(props) {
  return _react.default.createElement(_RouterCallout.default, (0, _extends2.default)({}, props, {
    footer: _react.default.createElement(_UIButton.default, {
      size: "extra-small",
      use: "tertiary"
    }, _react.default.createElement(_FormattedMessage.default, {
      message: getI18nKey('ctaButtonText')
    })),
    illustrationName: "team-alignment",
    primaryBackgroundColor: _colors.CALYPSO,
    secondaryBackgroundColor: _colors.OZ,
    subheader: _react.default.createElement(_FormattedMessage.default, {
      message: getI18nKey('subheadingText')
    }),
    title: _react.default.createElement(_FormattedMessage.default, {
      message: getI18nKey('titleText')
    }),
    to: (0, _urls.getCollectionUrl)(StorefrontCollection.ABM)
  }));
};

var _default = AbmCallout;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/storefront/callouts/AbmCallout.js
// module id = 893
// module chunks = 209 210 211 212